import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * Format number with locale separators
 */
export function formatNumber(n: number): string {
    return new Intl.NumberFormat('es-ES').format(n);
}

/**
 * Format a percentage with sign
 */
export function formatPercent(n: number, decimals = 1): string {
    const sign = n > 0 ? '+' : '';
    return `${sign}${n.toFixed(decimals)}%`;
}

/**
 * Format currency (EUR)
 */
export function formatCurrency(n: number): string {
    return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
    }).format(n);
}
